import { Entity } from '@backstage/catalog-model';
import type { EnvironmentBacking } from '@internal/plugin-environment-common';

export type EnvironmentRef = {
  name: string;
  backing?: EnvironmentBacking;
};

/**
 * Resolves which environment a catalog entity describes.
 *
 * The backing is recorded as an annotation so the frontend can skip the
 * backend's provider search, and so capability-dependent tabs can render the
 * right empty state before any request completes.
 */
export function getEnvironmentRef(entity: Entity): EnvironmentRef {
  const ann = entity.metadata.annotations ?? {};
  const backing = ann['environment/backing'] as EnvironmentBacking | undefined;
  return {
    name: ann['environment/name'] || entity.metadata.name,
    backing,
  };
}

/** True for catalog Resources that represent a developer environment. */
export function isEnvironmentResource(entity: Entity): boolean {
  return (
    entity.kind === 'Resource' &&
    (entity.spec?.type as string | undefined)?.toLowerCase() === 'environment'
  );
}
